/* eslint-disable @nx/enforce-module-boundaries */
import {
  Container,
  Stack,
  Card,
  HStack,
  Button,
  Heading,
  Text,
  VStack,
  CardBody,
  Flex,
} from '@mybridge/ui';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useDispatch, useSelector } from 'react-redux';
import { getGlobalCompanyTypes } from 'v4/store/actions/global.data.actions';

import { createCompanyPage } from 'v4/store/actions/companyPages.actions';
import { useToast } from '@chakra-ui/react';
import Link from 'next/link';
import Image from 'next/image';
import { BackArrow, BackArrowRTL } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
const CreateCompanyForm = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction =  useDirection();

 

  return (
    <Container maxW="1160px" p={3}>
        <HStack>
        <Button onClick={()=>{
          router.back()
        }} variant="ghost">
          {direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />}
        </Button>

        <Heading color="#3D5A80" fontWeight="500" fontSize="22px">
          {t('createPost.createPage') || "Create Page"}
        </Heading>
      </HStack>
      <VStack align="center" h="calc(85vh - 65px)" justifyContent="center">
        <Container>
          <Card boxShadow="none" border="none">
            <CardBody>
              <Flex
                direction="column"
                // h="430px"
                align="center"
                justifyContent="center"
                gap="15px"
              >
                {/* <Image src="/images/CreatePageDefault.svg" alt='Create company image' height={342} width={800} /> */}
                <Image src="/images/CreatePageDefault.png" alt='Create company image' height={120} width={290} priority style={{ opacity: 0.5 }} />
                <Heading
                  as="h2"
                  color="#5B5B5B"
                  fontSize="3xl"
                  fontWeight="normal"
                >
                  {t('createPage.createPage') || "Create a Page"}
                </Heading>
                <Text>
                {t('createPage.connectWithCommunity') || "Connect with friends, clients, employees, and the community."}
                </Text>
                {/* <Link href="/page/create/info" style={{width:'100%'}}> */}
                  <Button onClick={()=>router.push('/page/create/info')} borderRadius="50px" variant="primary" w="100%">
                    {t('myEvents.getStarted') || "Get Started"}
                  </Button>
                {/* </Link> */}
                {/* <Button
                  onClick={() => router.push('/settings/pages')}
                  style={{ background: 'transparent' }}
                >
                  Back
                </Button> */}
              </Flex>
            </CardBody>
          </Card>
        </Container>
      </VStack>
    </Container>
  );
};

export default CreateCompanyForm;
